// extracted by mini-css-extract-plugin
module.exports = {"balanceRow":"BalanceRow_balanceRow__2DRQd","assetName":"BalanceRow_assetName__1Zw3e","assetBalance":"BalanceRow_assetBalance__3STUO"};